import { render, staticRenderFns } from "./titulo.vue?vue&type=template&id=6d55bd01&"
import script from "./titulo.vue?vue&type=script&lang=ts&"
export * from "./titulo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports